export default "__VITE_ASSET__CK4fPj8c__"